<template>
  <div class>
    <modal full-header @close="closeModal">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ $t("message.termsAndConditions") }}</h2>
          </div>
          <p class="py-4" v-html="privacyAndPolicy()"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button class="privacy-btn pull-right" data-dismiss="modal">{{ $t('message.ok') }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import modal from "../../modal.vue";

export default {
  components: {
    modal
  },
  props: {
  },
  computed: {
    ...mapGetters(["currentStoreDoc","hqDoc"]),
  },
  methods: {
     privacyAndPolicy() {
      if (this.isBranded() && this.hqDoc && this.hqDoc.TermsAndConditions) {
        return this.hqDoc.TermsAndConditions;
      } else {
        return this.currentStoreDoc.TermsAndConditions;
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
  }
};
</script>
